import React from "react";

import Styles from "./BillingDataList.styles";
import { BillingDataListProps as Props } from "./BillingDataList.types";
import CommonPlaceholder from "components/global/CommonPlaceholder/CommonPlaceholder";
import ErrorBlock from "components/global/ErrorBlock/ErrorBlock";
import BillingDataPreview from "components/profile/BillingDataPreview/BillingDataPreview";
import useAuth from "contexts/auth/auth.context.hooks";
import useI18n from "hooks/useI18n";

import StudentSVG from "../../../../public/assets/images/student-large.svg";

const BillingDataList: React.FC<Props> = props => {
  const t = useI18n();
  const { actions, className, searchResult = "" } = props;
  const { billingDataList, isLoading, isError } = props;
  const auth = useAuth();
  const { uid } = auth;
  const billingDataListFilter = billingDataList?.filter(item =>
    item.name.toLocaleLowerCase().includes(searchResult.toLocaleLowerCase())
  );
  const empty = billingDataListFilter && billingDataListFilter.length === 0;

  const placeholdersNode = (
    <>
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
      <CommonPlaceholder />
    </>
  );

  const emptyNode = (
    <div className="BillingDataList__empty">
      <div className="BillingDataList__empty__icon">
        <StudentSVG />
      </div>
      <p className="BillingDataList__empty__title">{t.billing.saveYourData}</p>
      <p className="BillingDataList__empty__description">
        {t.billing.saveYourDataDescription}
      </p>
    </div>
  );

  const billingDataListNode = billingDataListFilter?.map((item, index) => {
    return (
      <div key={index} className="BillingDataList__item">
        <BillingDataPreview billingData={item} actions={actions} />
      </div>
    );
  });

  return (
    <Styles className={`BillingDataList ${className}`}>
      {isLoading ? placeholdersNode : null}
      {empty ? emptyNode : null}
      {isError ? <ErrorBlock queryKey={[uid, "billingData"]} /> : null}
      {!isLoading && !empty ? billingDataListNode : null}
    </Styles>
  );
};

BillingDataList.defaultProps = {
  className: ""
};

export default BillingDataList;
